import React from 'react';
import { Translation } from 'react-i18next';
import { Form, Select } from 'antd';
import { PublicStatusTag } from '../../../elements/components/Tags';

const PublicStatusInput = ({
  name,
  fieldKey = null,
  disabled = false,
  ...props
}) => {
  const options = [1, 2, 3];

  return (
    <Translation>
      {(t) => (
        <div
          className='form-group'
          style={{ display: 'flex', alignItems: 'center', gap: 8 }}
        >
          <Form.Item noStyle name={name || 'public_status'} fieldKey={fieldKey}>
            <Select
              bordered={false}
              showArrow
              dropdownMatchSelectWidth={false}
              className='public-status-select'
              disabled={disabled}
              defaultValue={2}
            >
              {options.map((x) => (
                <Select.Option key={x} value={x}>
                  <PublicStatusTag value={x} />
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      )}
    </Translation>
  );
};

export default PublicStatusInput;
